export default __webpack_public_path__ + "static/media/swipe-esg.f106f6cd.png";